import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/store";
import { customStylesSelector, clientSelector, quotesSelector } from "store/selectors/selectors";
import { COUNTRY } from "config";
import { createPurchase } from "api/siaApplication";
import { setPurchase, setLoadingValue } from "store/features/paymentSlice";
import { setErrorAndShowExitBtn } from "store/features/clientSlice";
import { setShowPaymentScreen } from "store/features/stepperSlice";
import CustomPayment from "./CustomPayment";

export type CustomPaymentWrapperProps = {
  onCancel: () => void;
  onSubmit: (details: any) => Promise<void>;
  customerEmail?: string;
  paymentData?: PaymentPayload[];
};

const CustomPaymentWrapper: React.FC<CustomPaymentWrapperProps> = ({
  onCancel,
  onSubmit,
  customerEmail,
  paymentData,
}) => {
  const dispatch = useDispatch();
  const customStyles = useSelector(customStylesSelector);
  const { clientAPIKey } = useSelector((state: RootState) => state.client);
  const productIdentifier = useSelector(
    (state: RootState) =>
      state.client.availableProducts[0]?.product?.product_identifier
  );
  const { showAutoRenewalSwitch } = useSelector(clientSelector);
  const isAutoRenewalAvailable = productIdentifier === "DRONE" && COUNTRY === "us";
  const showAutoRenew = showAutoRenewalSwitch && isAutoRenewalAvailable;
  const { selectedQuotes } = useSelector(quotesSelector);

  useEffect(() => {
      const [selectedQuote] = selectedQuotes;
      const _createPurchase = async () => {
        try {
          dispatch(setLoadingValue(true));
          const res = await createPurchase(clientAPIKey, {
            for_type: "quote",
            for_ids: [selectedQuote.id],
            auto_renewal_consent: false,
          })
          dispatch(setPurchase(res.data));
          dispatch(setLoadingValue(false));
          dispatch(setShowPaymentScreen(true));
        } catch {
          dispatch(setErrorAndShowExitBtn(true));
        } finally {
          dispatch(setLoadingValue(false));
        }
      }
      _createPurchase();
  }, [showAutoRenew, clientAPIKey, selectedQuotes, dispatch]);

  return (
    <CustomPayment
      onCancel={onCancel}
      onSubmit={onSubmit}
      customerEmail={customerEmail}
      paymentData={paymentData}
      showAutoRenew={showAutoRenew}
    />
  );
};

export default CustomPaymentWrapper;